import { createAxiosInstance } from '../utils/axios.js'

const api = createAxiosInstance()
const uploadApi = createAxiosInstance({
  headers: {
    'Content-Type': 'multipart/form-data'
  }
})

export const submissionService = {
  async uploadManuscriptFile (file) {
    try {
      const formData = new FormData()
      formData.append('file', file)
      const response = await uploadApi.post(
        '/api/user/upload/manuscript',
        formData
      )
      return { success: true, url: response.data.url }
    } catch (error) {
      return {
        success: false,
        error:
          error.response?.data?.error ||
          error.message ||
          'Failed to upload manuscript file'
      }
    }
  },

  async submitManuscript (data) {
    try {
      const response = await api.post('/api/user/manuscripts', data)
      return { success: true, data: response.data }
    } catch (error) {
      return {
        success: false,
        error:
          error.response?.data?.error ||
          error.response?.data?.message ||
          error.message ||
          'Failed to submit manuscript'
      }
    }
  }
}
